/**
 * @generated SignedSource<<6383b1b88a18583122d53d33c52b5fd7>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest, Query } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type SettingsIntegrationsPageQuery$variables = {};
export type SettingsIntegrationsPageQuery$data = {
  readonly settings: {
    readonly " $fragmentSpreads": FragmentRefs<"EtgSettings_settings" | "FacebookSettings_settings" | "GoogleSettings_settings" | "KiwiSettings_settings" | "PayseraSettings_settings" | "ScoroSettings_settings">;
  };
  readonly " $fragmentSpreads": FragmentRefs<"GoogleSettings_data">;
};
export type SettingsIntegrationsPageQuery = {
  response: SettingsIntegrationsPageQuery$data;
  variables: SettingsIntegrationsPageQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "apiKey",
  "storageKey": null
},
v1 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "key",
  "storageKey": null
};
return {
  "fragment": {
    "argumentDefinitions": [],
    "kind": "Fragment",
    "metadata": null,
    "name": "SettingsIntegrationsPageQuery",
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "Settings",
        "kind": "LinkedField",
        "name": "settings",
        "plural": false,
        "selections": [
          {
            "args": null,
            "kind": "FragmentSpread",
            "name": "KiwiSettings_settings"
          },
          {
            "args": null,
            "kind": "FragmentSpread",
            "name": "FacebookSettings_settings"
          },
          {
            "args": null,
            "kind": "FragmentSpread",
            "name": "EtgSettings_settings"
          },
          {
            "args": null,
            "kind": "FragmentSpread",
            "name": "PayseraSettings_settings"
          },
          {
            "args": null,
            "kind": "FragmentSpread",
            "name": "GoogleSettings_settings"
          },
          {
            "args": null,
            "kind": "FragmentSpread",
            "name": "ScoroSettings_settings"
          }
        ],
        "storageKey": null
      },
      {
        "args": null,
        "kind": "FragmentSpread",
        "name": "GoogleSettings_data"
      }
    ],
    "type": "Query",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [],
    "kind": "Operation",
    "name": "SettingsIntegrationsPageQuery",
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "Settings",
        "kind": "LinkedField",
        "name": "settings",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": "FlightsProviderSettings",
            "kind": "LinkedField",
            "name": "flightsProviderSettings",
            "plural": true,
            "selections": [
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "flightsProvider",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "baseUri",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "testMode",
                "storageKey": null
              },
              (v0/*: any*/),
              {
                "alias": null,
                "args": null,
                "concreteType": "KeyValuePair",
                "kind": "LinkedField",
                "name": "searchParams",
                "plural": true,
                "selections": [
                  (v1/*: any*/),
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "value",
                    "storageKey": null
                  }
                ],
                "storageKey": null
              }
            ],
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "concreteType": "FacebookSettings",
            "kind": "LinkedField",
            "name": "facebookSettings",
            "plural": false,
            "selections": [
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "pixelId",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "accessToken",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "testCode",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "loginAppId",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "loginAppSecret",
                "storageKey": null
              }
            ],
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "concreteType": "EtgSettings",
            "kind": "LinkedField",
            "name": "etg",
            "plural": false,
            "selections": [
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "keyId",
                "storageKey": null
              },
              (v1/*: any*/),
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "incrementalImport",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "incrementalBatchSize",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "fullLogContext",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "rateUpdatesEnabled",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "maxRateUpdateFrequency",
                "storageKey": null
              }
            ],
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "concreteType": "PayseraSettings",
            "kind": "LinkedField",
            "name": "paysera",
            "plural": false,
            "selections": [
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "projectId",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "lang",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "currency",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "paytext",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "password",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "acceptUrl",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "cancelUrl",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "callbackUrl",
                "storageKey": null
              }
            ],
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "concreteType": "GoogleSettings",
            "kind": "LinkedField",
            "name": "google",
            "plural": false,
            "selections": [
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "analyticsId",
                "storageKey": null
              },
              (v0/*: any*/),
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "loginClientId",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "loginClientSecret",
                "storageKey": null
              }
            ],
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "concreteType": "ScoroSettings",
            "kind": "LinkedField",
            "name": "scoro",
            "plural": false,
            "selections": [
              (v0/*: any*/),
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "apiUrl",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "ownerId",
                "storageKey": null
              }
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "googleCredentials",
        "storageKey": null
      }
    ]
  },
  "params": {
    "cacheID": "0f8dab20568ed83c7fa864b026d18dec",
    "id": null,
    "metadata": {},
    "name": "SettingsIntegrationsPageQuery",
    "operationKind": "query",
    "text": "query SettingsIntegrationsPageQuery {\n  settings {\n    ...KiwiSettings_settings\n    ...FacebookSettings_settings\n    ...EtgSettings_settings\n    ...PayseraSettings_settings\n    ...GoogleSettings_settings\n    ...ScoroSettings_settings\n  }\n  ...GoogleSettings_data\n}\n\nfragment EtgSettings_settings on Settings {\n  etg {\n    keyId\n    key\n    incrementalImport\n    incrementalBatchSize\n    fullLogContext\n    rateUpdatesEnabled\n    maxRateUpdateFrequency\n  }\n}\n\nfragment FacebookSettings_settings on Settings {\n  facebookSettings {\n    pixelId\n    accessToken\n    testCode\n    loginAppId\n    loginAppSecret\n  }\n}\n\nfragment GoogleCredentials_data on Query {\n  googleCredentials\n}\n\nfragment GoogleSettings_data on Query {\n  ...GoogleCredentials_data\n}\n\nfragment GoogleSettings_settings on Settings {\n  google {\n    analyticsId\n    apiKey\n    loginClientId\n    loginClientSecret\n  }\n}\n\nfragment KiwiSettings_settings on Settings {\n  flightsProviderSettings {\n    flightsProvider\n    baseUri\n    testMode\n    apiKey\n    searchParams {\n      key\n      value\n    }\n  }\n}\n\nfragment PayseraSettings_settings on Settings {\n  paysera {\n    projectId\n    lang\n    currency\n    paytext\n    password\n    acceptUrl\n    cancelUrl\n    callbackUrl\n  }\n}\n\nfragment ScoroSettings_settings on Settings {\n  scoro {\n    apiKey\n    apiUrl\n    ownerId\n  }\n}\n"
  }
};
})();

(node as any).hash = "2bb5e48b6c6f28f52a66dd772a8e8257";

export default node;
